import { AfterViewInit, Component, Type, ViewChild, ViewContainerRef, inject,
    ChangeDetectionStrategy
} from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from '@openng/optimus-ui/dynamicdialog';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { MainAppService } from 'src/modules/app-template/services/main-app.service';
import { Objects } from 'src/modules/utils/shared/objects';
import { ButtonDefinition } from '../../models/button-definition.model';
import { Arrays } from 'src/modules/utils/shared/arrays';

@Component({
    selector: 'app-container-dialog',
    templateUrl: './container-dialog.component.html',
    styleUrls: [],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        class: "height100p"
    }
})
export class ContainerDialogComponent extends ComponentView implements AfterViewInit {
    
    app = inject(MainAppService);
    ref = inject(DynamicDialogRef);
    config = inject(DynamicDialogConfig);
    
    @ViewChild('host', { read: ViewContainerRef, static: true }) host!: ViewContainerRef;

    buttons: ButtonDefinition[];
    instance: ComponentView;

    async ngAfterViewInit(): Promise<void> {
        const component = this.config.data.component as Type<ComponentView>;
        const inputs = (this.config.data.inputs ?? {}) as Record<string, unknown>;
        
        const cmpRef = this.host.createComponent(component);
        this.instance = cmpRef.instance;
        this.instance.embeddedComponent = true;
        this.instance.containerDialog = this;
        for (let key of Objects.getPropertyNames(inputs)) {
            this.instance[key] = inputs[key];
        }
        await this.instance.initEmbedded();
        this.buttons = Arrays.withoutNull(this.instance.getDialogButtons() ?? []);
    }

    async click(button: ButtonDefinition): Promise<void> {
        await this.buttonClick(button.id, async () => {
            await this.instance.buttonClickedFromExtern(button.id);
            if (this.config.data.outputs != null) {
                this.config.data.outputs.buttonClicked = button.id;
            }
        });
    }

    closeDialog(): void {
        this.ref.close(null);
    }
}
